import { render, staticRenderFns } from "./WebhookResource.vue?vue&type=template&id=40446e53&"
import script from "./WebhookResource.vue?vue&type=script&lang=js&"
export * from "./WebhookResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports